<template>
	<v-dialog v-model="openD" max-width="960" persistent>
		<v-card>
			<v-card-title class="headline">
				<span v-html="!result.id ? 'Nuevo rol' : 'Edición de rol ' + result.name"></span>
			</v-card-title>
			<v-card-text>
				<v-container grid-list-md>
					<v-layout wrap>
						<v-flex xs12>
							<v-text-field
									label="Nombre del rol"
									name="Nombre"
									v-model="result.name"
									prepend-icon="supervisor_account"
									v-validate="'required'"
									:error-messages="errors.collect('Nombre')"
							></v-text-field>
						</v-flex>
						<v-flex xs12 v-if="permisos">
							<v-list dense >
								<template v-for="(items, key) in permisos">
									<h3 class="mt-3 mb-0 pb-0">{{key}}</h3>
									<template v-for="(permiso, id) in items" style="margin-bottom: 20px; margin-left: 50px" >
										<v-list-tile :key="id+'-tile-'+key" >
											<v-list-tile-content>
												<v-list-tile-title>{{permiso && permiso.real_name}}</v-list-tile-title>
											</v-list-tile-content>
											<v-list-tile-action>
												<v-switch v-model="result.permissions"  :value="permiso"></v-switch>
											</v-list-tile-action>
										</v-list-tile>
										<v-divider></v-divider>
									</template>

								</template>
							</v-list>
						</v-flex>
						<v-flex v-else xs12 style="width: 100%; height: 80vh">
							<v-progress-linear :indeterminate="true"></v-progress-linear>
						</v-flex>
					</v-layout>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
						@click="close"
						:disabled="load"
				>
					Cancelar
				</v-btn>
				<v-btn
						color="primary"
						:loading="load"
						:disabled="load"
						@click="submit"
				>
					Registrar
				</v-btn>
			</v-card-actions>
		</v-card>
		<app-section-loader :status="loader"></app-section-loader>
	</v-dialog>
</template>

<script>
export default {
    data: () => ({
        openD: false,
        load: false,
		loader: false,
		permisos: [],
        result: {
            id: null,
            name: null,
			permissions: []
        }
	}),
	mounted() {
    	this.getPermissions()
	},
	methods: {
  	    submit () {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.loading()
					let request = this.result.id ? this.axios.put(`roles/${this.result.id}`, this.result) : this.axios.post(`roles`, this.result)
                    request
                        .then((response) => {
                            this.$emit('onSuccess', response.data)
                            this.$store.commit('snackbar', {color: 'success', message: `El rol se ha registrado correctamente`})
                            this.close()
                        }).catch(e => {
                        this.loading(false)
                        this.$store.commit('snackbar', {color: 'error', message: `al registrar la información del rol`, error: e})
                    })
				}
            })
		},
		getPermissions () {
            this.axios.get(`permisos`)
                .then(response => {
					this.permisos = response.data
                }).catch(e => {
                this.$store.commit('snackbar', {color: 'error', message: `al traer los permisos disponibles.`, error: e})
                this.close()
            })
        },
        getRol (id) {
            this.loading()
			this.loader = true
            this.axios.get(`roles/${id}`)
                .then(response => {
                    this.result = response.data
					this.result.permissions.forEach(function(value) {
						delete value.pivot;
					});
                    this.loading(false)
					setTimeout(() => {
						this.loader = false
					},300)

                }).catch(e => {
                this.loading(false)
				this.loader = false
                this.$store.commit('snackbar', {color: 'error', message: `al traer los datos del rol.`, error: e})
                this.close()
            })
        },
		open (id) {
  	        id && (this.getRol(id))
		  this.openD = true
		},
		loading (val = true) {
		  this.load = val
		},
		close () {
		  	this.openD = false
            setTimeout(() => {
                this.load = false
                this.loader = false
                this.result.id = null
                this.result.name = null
                this.result.permissions = []
                this.$validator.reset()
            }, 300)
		}
  	}
}
</script>

